import { createSelector } from '@reduxjs/toolkit';
import { selectInputType } from 'shared/selectors/jsonQuery';
import { EEntranceType } from '../../../../packages/api-models/common/json_query';

const OPTIONS = [
  { label: 'С улицы', value: EEntranceType.SeparateStreet },
  { label: 'Со двора', value: EEntranceType.SeparateCourtyard },
];

export const selectInputTypeFilter = createSelector(selectInputType, value => ({
  label: 'Вход',
  options: OPTIONS,
  value: value && value.length > 0 ? value : [null],
}));
